import { supabase } from './supabase';

export interface GhlSettings {
  locationId: string;
  pipelineId: string;
  pipelineStageId: string;
  hasCustomToken: boolean;
}

export async function fetchGhlSettings(coachId: string): Promise<GhlSettings | null> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { data, error } = await (supabase.rpc as any)('get_ghl_settings_status', {
    p_coach_id: coachId,
  });

  if (error || !data || data.length === 0) return null;

  const row = data[0] as {
    ghl_location_id: string | null;
    ghl_pipeline_id: string | null;
    ghl_pipeline_stage_id: string | null;
    has_custom_token: boolean;
  };

  return {
    locationId: row.ghl_location_id ?? '',
    pipelineId: row.ghl_pipeline_id ?? '',
    pipelineStageId: row.ghl_pipeline_stage_id ?? '',
    hasCustomToken: row.has_custom_token ?? false,
  };
}

export async function saveGhlSettings(
  coachId: string,
  settings: {
    locationId: string;
    pipelineId: string;
    pipelineStageId: string;
    customToken?: string;
  },
): Promise<void> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { error } = await (supabase.from('coaches') as any)
    .update({
      ghl_location_id: settings.locationId.trim() || null,
      ghl_pipeline_id: settings.pipelineId.trim() || null,
      ghl_pipeline_stage_id: settings.pipelineStageId.trim() || null,
    })
    .eq('id', coachId);

  if (error) throw error;

  const trimmedToken = settings.customToken?.trim() ?? '';
  if (trimmedToken.length > 0) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { error: rpcError } = await (supabase.rpc as any)('save_ghl_token', {
      p_coach_id: coachId,
      p_token: trimmedToken,
    });
    if (rpcError) throw rpcError;
  }
}
